var map = {
	"./africa/game.layout.vue": [
		"gP5C",
		5
	],
	"./club-soft/game.layout.vue": [
		"veUq",
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "tfGd";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/layouts/game lazy ^\.\/.*\/game\.layout\.vue$
// module id = tfGd
// module chunks = 37